import type {UserFacingEntity} from '../../../../../ui/core-entity/rows/peep-rows/types';

import {Dialog} from '../dialog/dialog';

import {getDialogPropsFromType} from './helpers';
import type {CoreEntityConfirmationType} from './types';

type Props = {
    anchor: HTMLElement | null | undefined;
    type: CoreEntityConfirmationType;
    parentEntity: UserFacingEntity;
    onConfirm: () => void;
    onCancel: () => void;
};

export function CoreEntityConfirmationDialog(props: Props) {
    const dialogProps = getDialogPropsFromType(props.type, props.parentEntity);

    return (
        <Dialog
            anchor={props.anchor}
            question={dialogProps.question}
            primaryText={dialogProps.primaryText}
            secondaryText={dialogProps.secondaryText}
            onPrimary={props.onConfirm}
            onSecondary={props.onCancel}
            isWarning={true}
            customStyles={{width: dialogProps.width}}
        />
    );
}
